// extracted by mini-css-extract-plugin
module.exports = {"icon":"button-overlay_icon__1yaDr","buttonOverlay":"button-overlay_buttonOverlay__3TsZT"};